// extracted by mini-css-extract-plugin
export default {"edit":"edit_edit__sTFyZ","page":"edit_page__0mAa+","rotate":"edit_rotate__eDnv-"};